var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuestDasboardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Dasboard_icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dasboard_icon",
    "data-name": "Dasboard icon",
    clipPath: "url(#clip-Dasboard_icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grid",
    transform: "translate(-2.381 -0.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H4.233V4.233H0Z",
    transform: "translate(3 2.427)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H4.233V4.233H0Z",
    transform: "translate(8.776 4.544) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H4.233V4.233H0Z",
    transform: "translate(9.653 9.08)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H4.233V4.233H0Z",
    transform: "translate(3 9.08)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestDasboardicon);
export default __webpack_public_path__ + "static/media/GuestDasboard icon.4525fb9160d540a4ee529e869be847c1.svg";
export { ForwardRef as ReactComponent };